import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useFamilyAuth = create(
  persist(
    (set) => ({
      token: null,
      family: null,
      setAuth: ({ token, family }) => set({ token, family }),
      setFamily: (family) => set({ family }),
      logout: () => set({ token: null, family: null }),
    }),
    { name: "strideFamilyAuth" }
  )
);
